import { render, staticRenderFns } from "./editMaterial.vue?vue&type=template&id=9269cd1e&scoped=true&"
import script from "./editMaterial.vue?vue&type=script&lang=js&"
export * from "./editMaterial.vue?vue&type=script&lang=js&"
import style0 from "./editMaterial.vue?vue&type=style&index=0&id=9269cd1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9269cd1e",
  null
  
)

export default component.exports